import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import Dialog, { useDialog, useDialogContext } from "@imminently/decisively-ui/Dialog";
import { DialogHeader } from "@/ui/dialogs/DialogHeader";
import CheckboxField from "@imminently/decisively-ui/CheckboxField";
import { WORKSPACE_LAYER } from "@/ui/dialogs/layers";
import { exportModel } from "../../redux";

interface ProjectLike {
  id: string;
  name?: string;
}

interface ExportProjectModalProps {
  project: ProjectLike;
  close: () => void;
}

const ExportProjectModal = ({ project }: ExportProjectModalProps) => {
  const dispatch = useDispatch();
  const dialogContext = useDialogContext();
  const [includeScenarios, setIncludeScenarios] = useState(true);

  const handleExport = () => {
    dispatch(
      exportModel(project.id, {
        includeScenarios,
        fallbackProjectName: project.name,
      }),
    );
    dialogContext?.close();
  };

  return (
    <Dialog.Content className="flex flex-col">
      <DialogHeader title="Export Project" />

      <Dialog.Body>
        <CheckboxField
          value={includeScenarios}
          name="scenarios"
          label="Include Scenarios"
          onValueChange={setIncludeScenarios}
        />
      </Dialog.Body>

      <Dialog.Actions>
        <Dialog.Actions.CancelButton label="Cancel">Cancel</Dialog.Actions.CancelButton>
        <Dialog.Actions.PrimaryButton
          onClick={handleExport}
          label="Export"
        >
          Export
        </Dialog.Actions.PrimaryButton>
      </Dialog.Actions>
    </Dialog.Content>
  );
};

export const useExportProjectModal = () => {
  const { pushDialog } = useDialog();

  return useCallback(
    (project: ProjectLike) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: (props) => (
          <ExportProjectModal
            {...props}
            project={project}
          />
        ),
      });
    },
    [pushDialog],
  );
};
